export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50];

export const MAX_SHOW_PAGING_PAGE = 3;

export const MAX_RETRY_ATTEMPT = 3;

export const SLEEP_TIMEOUT = 200; // ms

export const CHAT_MESSAGE_MAX_LENGTH = 200;

export const ORDER_AUTO_RELOAD_INTERVAL = 30000;

export const COMMON_CONST = {
  PageSize: 20,
  FormatDayView: 'DD-MM-YYYY',
  FormatDateView: 'DD/MM/YYYY - HH:mm',
  FormatDateTimeView: 'DD/MM/YYYY - hh:mm A',
  FormatDateTypeView: 'd/m/Y',
  FormatDateTimeTypeView: 'd/m/Y - H:i',
  FormatDate: 'YYYY-MM-DD',
  FormatDateTime: 'YYYY-MM-DD HH:mm:ss',
  FormatPhoneNumber: '#### ### ###',
  FormatTimeDateView: 'HH:mm - DD/MM/YYYY',
};

export const VERSION_CONFIG = {
  Th: 'th',
};

export const IGNORE_ERROR = true;

export const UNSET_DEFAULT_VALUE = -1;

export const RESTAURANT_MQTT_TOPIC = '/restaurant/';

export const NOW_TABLE_MQTT_TOPIC = '/nowtable/merchant/';

export const NOW_SHIP_MQTT_TOPIC = '/nowship/merchant/';

export const NOW_ORDER_MQTT_TOPIC = 'delil/';

export const NOW_SHIP_RADIUS_SHIPPER_ON_MAP = 2000;

export const NOW_SHIP_REQUEST_COUNT = 10;

export const NOW_SHIP_MAX_ANIMATION_DISTANCE = 5; // km

export const NOW_SHIP_MAX_ANIMATION_STEP = 100;

export const NOW_SHIP_ANIMATION_STEP_DURATION = 50; // ms

export const NOW_SHIP_LOCK_AUTO_MOVE_MAP_DURATION = 7000; // ms

export const NOW_PORTAL_WITHDRAW_MIN_THRESHOLD = 100000;

export const NOW_PORTAL_WITHDRAW_AUTO_MIN_THRESHOLD = 500000;

export const NOW_PORTAL_DAILY_LEFTOVER_BALANCE = 100000;

export const MAX_LENGTH_IDS_REQUEST = 100;

export const DEFAULT_FILE_NAME = 'download.xls';

export const ERROR_ACCESS_TOKEN_CODE = 'error_access_token';

export const ERROR_PARAMS = 'error_params';

export const ERROR_ACCOUNT_DELETED = 'error_account_deleted';

export const SUCCESS_RESPONSE = 'success';

export const CHAT_AMOUNT_PIXEL_SCROLL_DOWN = 500;

export const TEMPLATE_NOTE_ID_NOT_FOUND_SHIPPER = 6;

export const ERROR_FORCE_VERIFY_ACCOUNT = 'error_force_verify_account';

export const VERIFIED_OTP = '1';



// WEBPACK FOOTER //
// ./foody/src/constants/constants.js